import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import React from "react";
import { Create, SimpleForm, useNotify } from "react-admin";
import CreateForm from "./CreateForm";
import { useLocation, useNavigate } from "react-router-dom";
import { ATTESTATIONS, GraduationServicePath, MONTHLY_INTERNSHIP } from "utils/constants";

const CreateMonthlyInternshipAttestations = () => {
  const notify = useNotify();
  const navigate = useNavigate();
  const location = useLocation();
  const studentEducationId = location?.state?.studentEducationId;
  const lastAttestationDate = location?.state?.lastAttestationDate;
  const startDate = location?.state?.startDate;

  const onSuccess = () => {
    notify("Успешно създаване на държавен изпит", { type: "success" });
    navigate(-1);
  };
  return (
    <>
      <Create
        resource={`${GraduationServicePath}students/${studentEducationId}/${MONTHLY_INTERNSHIP}/${ATTESTATIONS}`}
        title="Добави заверка за месечен стаж"
        actions={<BackButtonToolbar />}
        mutationOptions={{ onSuccess }}
      >
        <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
          <CreateForm
            lastAttestationDate={lastAttestationDate}
            startDate={startDate}
          />
        </SimpleForm>
      </Create>
    </>
  );
};

export default CreateMonthlyInternshipAttestations;
